// Script para validar selección de variantes en Shopify (con soporte para URL variant)
(function () {
  'use strict';

  const CONFIG = {
    selectors: {
      productForm: 'form[id*="product-form"], form[action*="/cart/add"]',
      addToCartButton: '#AddToCart',
      tallaInputs: 'input[name="Talla"]',
      tallaFieldset: 'fieldset[data-handle="talla"]'
    },

    // Values that do not require manual selection
    autoSelectValues: [
      'unitalla',
      'sin',
      'única',
      'unica',
      'one size',
      'onesize',
      'talla única'
    ],

    messages: {
      selectVariant:
        'Por favor, selecciona una talla antes de agregar al carrito.'
    },

    errorStyles: {
      color: '#d32f2f',
      fontSize: '14px',
      marginTop: '10px',
      padding: '8px 12px',
      backgroundColor: '#ffebee',
      border: '1px solid #ffcdd2',
      borderRadius: '4px',
      display: 'block',
      fontWeight: 'bold'
    },

    debug: true
  };

  let defaultSelectionHandled = false;
  let observerReinitTimer = null;
  let initializationInProgress = false;

  function debugLog(message, data = null) {
    if (!CONFIG.debug) return;

    console.log(
      '🔍 [Shopify Validator]',
      message,
      data !== null ? data : ''
    );
  }

  function getURLParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  function getVariantFromURL() {
    const variantId = getURLParameter('variant');
    debugLog('Variant ID desde URL:', variantId);

    return variantId;
  }

  function escapeSelectorValue(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value));
    }

    return String(value).replace(/["\\]/g, '\\$&');
  }

  function updateTallaLabel(selectedValue) {
    const labelValue = document.querySelector('.form__label__value');

    if (labelValue) {
      labelValue.textContent = selectedValue || '';
      debugLog('Texto de talla actualizado:', selectedValue);
    }
  }

  function dispatchVariantChange(input) {
    if (!input) return;

    input.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }

  function findTallaForVariant(variantId) {
    const tallaInputs = document.querySelectorAll(
      CONFIG.selectors.tallaInputs
    );

    for (const input of tallaInputs) {
      const inputVariantId =
        input.getAttribute('data-variant-id') ||
        input.getAttribute('data-variant');

      if (String(inputVariantId) === String(variantId)) {
        return input;
      }
    }

    return null;
  }

  function selectTallaInput(input, dispatchChange = false) {
    if (!input) return false;

    const wasAlreadyChecked = input.checked;

    input.checked = true;
    updateTallaLabel(input.value);

    if (dispatchChange && !wasAlreadyChecked) {
      dispatchVariantChange(input);
    }

    return true;
  }

  function selectVariantFromURL(variantId) {
    if (!variantId) {
      debugLog('No hay variant ID en la URL');
      return false;
    }

    debugLog('=== SELECCIONANDO VARIANTE DESDE URL ===');
    debugLog('Buscando variant ID:', variantId);

    const variantInputs = document.querySelectorAll('input[name="id"]');
    const tallaInputs = document.querySelectorAll(
      CONFIG.selectors.tallaInputs
    );

    debugLog(`Inputs de variant encontrados: ${variantInputs.length}`);
    debugLog(`Inputs de talla encontrados: ${tallaInputs.length}`);

    /*
     * Method 1:
     * Find a matching hidden Shopify variant input, then find its size.
     */
    for (const input of variantInputs) {
      if (String(input.value) !== String(variantId)) continue;

      const correspondingTalla = findTallaForVariant(variantId);

      if (correspondingTalla) {
        selectTallaInput(correspondingTalla, true);

        debugLog(
          '✅ Talla seleccionada desde URL:',
          correspondingTalla.value
        );

        return true;
      }
    }

    /*
     * Method 2:
     * Check variant data attributes on size inputs.
     */
    for (const tallaInput of tallaInputs) {
      const inputVariantId =
        tallaInput.getAttribute('data-variant-id') ||
        tallaInput.getAttribute('data-variant') ||
        tallaInput.getAttribute('value-variant-id');

      if (String(inputVariantId) !== String(variantId)) continue;

      selectTallaInput(tallaInput, true);

      debugLog(
        '✅ Talla seleccionada desde URL mediante data attribute:',
        tallaInput.value
      );

      return true;
    }

    /*
     * Method 3:
     * Find any DOM element containing the variant ID.
     */
    const escapedVariantId = escapeSelectorValue(variantId);

    const variantElements = document.querySelectorAll(
      `[data-variant-id="${escapedVariantId}"]`
    );

    for (const element of variantElements) {
      const tallaValue =
        element.getAttribute('data-value') ||
        element.getAttribute('data-option-value') ||
        element.textContent.trim();

      if (!tallaValue) continue;

      const escapedTallaValue = escapeSelectorValue(tallaValue);

      const tallaInput = document.querySelector(
        `input[name="Talla"][value="${escapedTallaValue}"]`
      );

      if (!tallaInput) continue;

      selectTallaInput(tallaInput, true);

      debugLog(
        '✅ Talla seleccionada desde elemento DOM:',
        tallaValue
      );

      return true;
    }

    /*
     * Method 4:
     * Use Shopify Analytics product data when available.
     */
    const productData =
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.product;

    if (productData && Array.isArray(productData.variants)) {
      const variant = productData.variants.find(
        (item) => String(item.id) === String(variantId)
      );

      if (variant && Array.isArray(variant.options)) {
        const tallaValue = variant.options[1] || variant.options[0];

        if (tallaValue) {
          const escapedTallaValue = escapeSelectorValue(tallaValue);

          const tallaInput = document.querySelector(
            `input[name="Talla"][value="${escapedTallaValue}"]`
          );

          if (tallaInput) {
            selectTallaInput(tallaInput, true);

            debugLog(
              '✅ Talla seleccionada desde Shopify Analytics:',
              tallaValue
            );

            return true;
          }
        }
      }
    }

    debugLog(
      '❌ No se pudo encontrar la talla para el variant ID:',
      variantId
    );

    return false;
  }

  function isAutoSelectValue(value) {
    if (!value) return false;

    const normalizedValue = String(value).toLowerCase().trim();

    return CONFIG.autoSelectValues.some(
      (autoValue) =>
        normalizedValue === String(autoValue).toLowerCase().trim()
    );
  }

  function handleDefaultSelection() {
    const tallaInputs = document.querySelectorAll(
      CONFIG.selectors.tallaInputs
    );

    if (!tallaInputs.length) {
      debugLog('Todavía no hay inputs de talla');
      return false;
    }

    /*
     * Important fix:
     * Do not repeat the default-selection process whenever Judge.me or
     * Shopify modifies the page DOM.
     */
    if (defaultSelectionHandled) {
      debugLog('Selección inicial ya procesada; no se repite');
      return isTallaSelected();
    }

    defaultSelectionHandled = true;

    debugLog('=== MANEJANDO SELECCIÓN POR DEFECTO ===');

    const urlVariantId = getVariantFromURL();

    if (urlVariantId) {
      debugLog('🔗 Variant ID detectado en URL:', urlVariantId);

      if (selectVariantFromURL(urlVariantId)) {
        debugLog('✅ Variante seleccionada desde URL exitosamente');
        return true;
      }

      debugLog(
        '⚠️ No se encontró la variante de URL; continuando con la lógica normal'
      );
    }

    let hasAutoSelectValue = false;
    let changedInput = null;

    tallaInputs.forEach((input, index) => {
      const inputValue = input.value;
      const isAutoSelect = isAutoSelectValue(inputValue);

      debugLog(`Input ${index + 1}:`, {
        value: inputValue,
        checked: input.checked,
        isAutoSelect
      });

      if (isAutoSelect) {
        hasAutoSelectValue = true;

        if (!input.checked) {
          input.checked = true;
          changedInput = input;

          debugLog(`✅ Auto-seleccionando: ${inputValue}`);
        }

        updateTallaLabel(inputValue);
        return;
      }

      /*
       * Clear theme default selections only when the URL does not specify
       * a variant.
       */
      if (!urlVariantId && input.checked) {
        input.checked = false;
        changedInput = input;

        debugLog(`❌ Quitando selección de: ${inputValue}`);
      }
    });

    if (!hasAutoSelectValue && !urlVariantId) {
      updateTallaLabel('');
    }

    /*
     * Important fix:
     * Dispatch only one change event instead of dispatching a change
     * event on every size input.
     */
    if (changedInput) {
      dispatchVariantChange(changedInput);
    }

    return hasAutoSelectValue || Boolean(urlVariantId);
  }

  function showErrorMessage(message) {
    const existingError = document.querySelector(
      '.variant-error-message'
    );

    if (existingError) {
      existingError.remove();
    }

    const errorDiv = document.createElement('div');

    errorDiv.className = 'variant-error-message';
    errorDiv.textContent = message;

    Object.assign(errorDiv.style, CONFIG.errorStyles);

    const addButton = document.querySelector(
      CONFIG.selectors.addToCartButton
    );

    if (addButton && addButton.parentNode) {
      addButton.parentNode.insertBefore(
        errorDiv,
        addButton.nextSibling
      );
    } else {
      const tallaFieldset = document.querySelector(
        CONFIG.selectors.tallaFieldset
      );

      if (tallaFieldset && tallaFieldset.parentNode) {
        tallaFieldset.parentNode.insertBefore(
          errorDiv,
          tallaFieldset.nextSibling
        );
      } else {
        document.body.appendChild(errorDiv);
      }
    }

    setTimeout(() => {
      if (!document.documentElement.contains(errorDiv)) return;

      const rect = errorDiv.getBoundingClientRect();

      const isVisible =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight ||
            document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth ||
            document.documentElement.clientWidth);

      if (!isVisible) {
        debugLog(
          'Mensaje de error no visible; desplazando hacia el mensaje'
        );

        errorDiv.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
      }
    }, 100);

    setTimeout(() => {
      if (errorDiv.parentNode) {
        errorDiv.remove();
      }
    }, 8000);
  }

  function hideErrorMessage() {
    const errorMessage = document.querySelector(
      '.variant-error-message'
    );

    if (errorMessage) {
      errorMessage.remove();
    }
  }

  function isTallaSelected() {
    const tallaInputs = document.querySelectorAll(
      CONFIG.selectors.tallaInputs
    );

    if (!tallaInputs.length) {
      debugLog('No hay inputs de talla; asumiendo selección válida');
      return true;
    }

    for (const input of tallaInputs) {
      if (input.type === 'radio' && input.checked) {
        debugLog('✅ Talla seleccionada:', input.value);
        return true;
      }
    }

    debugLog('❌ No hay talla seleccionada');
    return false;
  }

  function validateSelection() {
    debugLog('=== VALIDANDO SELECCIÓN ===');

    if (!isTallaSelected()) {
      debugLog('❌ VALIDACIÓN FALLIDA');
      showErrorMessage(CONFIG.messages.selectVariant);

      return false;
    }

    debugLog('✅ VALIDACIÓN EXITOSA');
    hideErrorMessage();

    return true;
  }

  function blockFormSubmission(event) {
    debugLog('🚨 Intento de envío interceptado');

    if (validateSelection()) {
      debugLog('✅ PERMITIENDO envío');
      return true;
    }

    debugLog('🛑 BLOQUEANDO envío');

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    return false;
  }

  function bindForm(form) {
    if (!form || form.dataset.shopifyValidatorBound === 'true') {
      return;
    }

    form.dataset.shopifyValidatorBound = 'true';

    form.addEventListener('submit', blockFormSubmission, true);

    /*
     * Prevent the programmatic submit override from being applied
     * repeatedly.
     */
    if (!form.dataset.shopifyValidatorSubmitWrapped) {
      form.dataset.shopifyValidatorSubmitWrapped = 'true';

      const originalSubmit = form.submit;

      form.submit = function () {
        debugLog('Submit programático interceptado');

        if (validateSelection()) {
          originalSubmit.call(this);
        }
      };
    }

    debugLog('✅ Formulario configurado:', form.id || form);
  }

  function bindAddToCartButton(button) {
    if (
      !button ||
      button.dataset.shopifyValidatorBound === 'true'
    ) {
      return;
    }

    button.dataset.shopifyValidatorBound = 'true';

    ['click', 'mousedown', 'touchstart'].forEach((eventType) => {
      button.addEventListener(
        eventType,
        function (event) {
          debugLog(`🚨 Evento ${eventType} en AddToCart`);

          if (validateSelection()) return;

          debugLog('🛑 BLOQUEANDO clic en botón');

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
        },
        true
      );
    });

    debugLog('✅ Botón AddToCart configurado');
  }

  function bindTallaInput(input) {
    if (
      !input ||
      input.dataset.shopifyValidatorBound === 'true'
    ) {
      return;
    }

    input.dataset.shopifyValidatorBound = 'true';

    input.addEventListener('change', function () {
      debugLog('Cambio en talla detectado:', this.value);

      if (this.checked) {
        updateTallaLabel(this.value);
      }

      setTimeout(() => {
        if (isTallaSelected()) {
          hideErrorMessage();
        }
      }, 50);
    });
  }

  function isJudgeMeHash() {
    return (
      window.location.hash === '#judgeme_product_reviews' ||
      window.location.hash.startsWith('#judgeme_product_reviews')
    );
  }

  function preserveReviewScrollPosition(callback) {
    const shouldPreserve =
      isJudgeMeHash() && window.scrollY > 100;

    const savedScrollY = window.scrollY;

    callback();

    if (!shouldPreserve) return;

    /*
     * Restore the previous position only when another script unexpectedly
     * sends the page near the top during initialization.
     */
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const unexpectedlyMovedToTop =
          window.scrollY < 100 &&
          savedScrollY > 100;

        if (unexpectedlyMovedToTop) {
          debugLog(
            'Restaurando posición de scroll de Judge.me:',
            savedScrollY
          );

          window.scrollTo({
            top: savedScrollY,
            left: 0,
            behavior: 'auto'
          });
        }
      });
    });
  }

  function setupValidation() {
    debugLog('=== CONFIGURANDO VALIDACIÓN ===');

    handleDefaultSelection();

    const forms = document.querySelectorAll(
      CONFIG.selectors.productForm
    );

    forms.forEach(bindForm);

    const addButtons = document.querySelectorAll(
      CONFIG.selectors.addToCartButton
    );

    addButtons.forEach(bindAddToCartButton);

    const tallaInputs = document.querySelectorAll(
      CONFIG.selectors.tallaInputs
    );

    tallaInputs.forEach(bindTallaInput);

    debugLog('Configuración finalizada:', {
      forms: forms.length,
      buttons: addButtons.length,
      tallaInputs: tallaInputs.length
    });
  }

  function init() {
    if (initializationInProgress) {
      return;
    }

    initializationInProgress = true;

    try {
      preserveReviewScrollPosition(() => {
        setupValidation();
      });

      debugLog('✅ Inicialización completada');
    } catch (error) {
      console.error(
        '❌ Error en inicialización del validador:',
        error
      );
    } finally {
      initializationInProgress = false;
    }
  }

  function nodeBelongsToJudgeMe(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) {
      return false;
    }

    return Boolean(
      node.closest(
        '#judgeme_product_reviews, ' +
          '.jdgm-widget, ' +
          '[class*="jdgm-"], ' +
          '[class*="jm-"]'
      )
    );
  }

  function nodeContainsProductElements(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) {
      return false;
    }

    if (nodeBelongsToJudgeMe(node)) {
      return false;
    }

    const matchesProductElement =
      typeof node.matches === 'function' &&
      node.matches(
        `${CONFIG.selectors.productForm}, ` +
          `${CONFIG.selectors.addToCartButton}, ` +
          `${CONFIG.selectors.tallaInputs}`
      );

    if (matchesProductElement) {
      return true;
    }

    if (typeof node.querySelector !== 'function') {
      return false;
    }

    return Boolean(
      node.querySelector(
        `${CONFIG.selectors.productForm}, ` +
          `${CONFIG.selectors.addToCartButton}, ` +
          `${CONFIG.selectors.tallaInputs}`
      )
    );
  }

  function scheduleReinitialization() {
    clearTimeout(observerReinitTimer);

    observerReinitTimer = setTimeout(() => {
      init();
    }, 150);
  }

  function startObserver() {
    if (!document.body) return;

    const observer = new MutationObserver((mutations) => {
      let shouldReinitialize = false;

      for (const mutation of mutations) {
        if (!mutation.addedNodes.length) continue;

        for (const node of mutation.addedNodes) {
          if (nodeContainsProductElements(node)) {
            shouldReinitialize = true;
            break;
          }
        }

        if (shouldReinitialize) break;
      }

      if (shouldReinitialize) {
        debugLog(
          'Contenido del producto detectado; reinicializando de forma segura'
        );

        scheduleReinitialization();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function start() {
    init();

    /*
     * These delayed checks remain for themes that load the product form
     * asynchronously. Duplicate listeners are prevented by data attributes.
     */
    setTimeout(init, 500);
    setTimeout(init, 1500);

    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {
      once: true
    });
  } else {
    start();
  }

  /*
   * Manual debugging helpers.
   */
  window.shopifyValidatorTest = function () {
    console.log('=== TEST MANUAL ===');
    console.log('URL:', window.location.href);
    console.log('Hash:', window.location.hash);
    console.log('Scroll Y:', window.scrollY);
    console.log('Parámetro variant:', getVariantFromURL());
    console.log('¿Talla seleccionada?', isTallaSelected());

    const allTallas = document.querySelectorAll(
      CONFIG.selectors.tallaInputs
    );

    console.log(
      'Todas las tallas:',
      Array.from(allTallas).map((input) => ({
        value: input.value,
        checked: input.checked,
        isAutoSelect: isAutoSelectValue(input.value),
        variantId:
          input.getAttribute('data-variant-id') ||
          input.getAttribute('data-variant')
      }))
    );
  };

  window.shopifyValidatorSelectVariant = function (variantId) {
    console.log(
      'Seleccionando variant manualmente:',
      variantId
    );

    return selectVariantFromURL(variantId);
  };
})();